<template>
  <div class="offer-plan-box">
    <div v-if="isSignature" class="pb-5">Planos Salvos</div>
    <div v-else class="pb-5">Ofertas Salvas</div>

    <span v-if="!items.length">
      <img class="d-block mb-5 mx-auto" src="@/assets/images/no-content.svg" />

      <h4 class="text-center">
        Você não possui nenhuma oferta salva no momento
      </h4>
    </span>

    <div v-else class="box p-5">
      <div
        v-for="(item, index) in items"
        :key="index"
        class="container-selected d-flex flex-column align-items-start justify-content-center"
      >
        <div
          v-if="isSignature"
          class="d-flex align-items-center text-secondary w-100"
        >
          <OfferOrPlanItem
            :item="item"
            :index="index"
            :isSignature="true"
            @edit="e => editItems(e)"
            @delete="e => toggleModal(e)"
          />
        </div>
        <div v-else class="w-100">
          <OfferOrPlanItem
            :item="item"
            :index="index"
            @edit="e => editItems(e)"
            @delete="e => toggleModal(e)"
          />
        </div>
      </div>
      <bp-dialog
        v-bind="deleteDialog"
        @action="closeModal"
        @secondary-action="removeItem"
      />
    </div>
  </div>
</template>

<script>
import { formatMoney } from "@/functions/helpers";
import moment from "moment";
import OfferOrPlanItem from "./OfferOrPlanItem.vue";

export default {
  components: {
    OfferOrPlanItem
  },
  props: {
    items: {
      type: Array,
      default: () => []
    },
    isSignature: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      indexToDelete: null,
      deleteDialog: {
        variant: "negative",
        value: false,
        text: `Tem certeza que deseja excluir ${
          this.isSignature ? "o plano" : "a oferta"
        }?`,
        icon: "fa fa-circle-trash",
        buttonText: "Não",
        secondaryButtonText: "Sim"
      }
    };
  },
  methods: {
    formatDate(item) {
      const start = moment(item.start_at).format("DD/MM/YYYY");
      if (item.end_at) {
        const end = moment(item.end_at).format("DD/MM/YYYY");
        return `${start} - ${end}`;
      }
      return `Inicia em ${start}, sem data limite.`;
    },
    editItems(index) {
      this.$emit("edit", index);
    },
    formatPrice(val) {
      return formatMoney(val);
    },
    cancel() {
      this.$emit("cancel");
    },
    removeItem() {
      this.$emit("delete", this.indexToDelete);
      this.deleteDialog.value = false;
    },
    toggleModal(index) {
      this.deleteDialog.value = true;
      this.indexToDelete = index;
    },
    closeModal() {
      this.deleteDialog.value = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.offer-plan-box {
  @media screen and (max-width: 991px) {
    h6 {
      font-size: 16px;
    }
  }
  .box {
    background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='4' ry='4' stroke='%23D2D0D8FF' stroke-width='2' stroke-dasharray='10 10' stroke-dashoffset='4' stroke-linecap='round'/%3e%3c/svg%3e");
    border-radius: 4px !important;
    background-color: no-repeat;
    background-color: rgba(255, 255, 255, 0.1);
    width: 100%;
  }

  .container-selected {
    padding: 12px 20px;
    border-radius: 4px;
    border: 1px solid #d2d0d8;
    position: relative;
    width: 100%;
    transition: 0.3s all ease-in-out;

    &:not(:first-child) {
      margin-top: 8px;
    }

    span {
      font-weight: normal !important;
    }
    &:has(div.show) {
      background-color: white;
      box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.12);
    }
  }
  .square-divider {
    width: 4px;
    height: 4px;
    background: #acabae;
    border-radius: 8px;
  }
}
</style>
